import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from "./components/home/home.component";
import { CategoryComponent } from "./components/category/category.component";
import { LoginComponent } from "./components/login/login.component";
import { RegisterComponent } from "./components/register/register.component";
import { CartComponent } from "./components/cart/cart.component";
import { CheckoutComponent } from "./components/checkout/checkout.component";
import { ProductComponent } from "./components/product/product.component";
import { ThankyouComponent } from "./components/thankyou/thankyou.component";
import { PublicGuard } from './guards/public.guard';

const routes: Routes = [
  {
    path: '', component: HomeComponent
  },
  { 
    path: 'search', component: HomeComponent } ,

  { 
     path: 'product-category/:category', component: CategoryComponent
  },
  { 
     path: 'product-category/:category/:subcategory', component: CategoryComponent
  },
  {
    path: 'product/:slugAndId', component: ProductComponent
  },
  {
    path: 'cart', component: CartComponent
  },
  {
    path: 'checkout', component: CheckoutComponent
  },
  {
    path: 'thankyou', component: ThankyouComponent
  },
  {
    path: 'login', component: LoginComponent, canActivate: [PublicGuard]
  },
  {
    path: 'register', component: RegisterComponent, canActivate: [PublicGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }

